module.exports = __webpack_public_path__ + "img/52-white.41fa18ad.svg";